module.exports = __webpack_public_path__ + "img/file2.ddfa0ea9.png";